import { Box, Grid2, Typography } from '@mui/material';
import PointIcon from '../icons/Point';
import AvatarClump from './AvatarClump';

export default function Staircase({avatarCount, actualAvatar}) {
    return (
        <Grid2 container
            sx={{
                alignItems: 'flex-end',
            }}
        >
            {/* Step 1 */}
            <Grid2 size={2.4}>
                <AvatarClump numberOfAvatars={avatarCount[4]} avatarType={0} actualAvatar={actualAvatar} />
                <Box className="staircase-block" sx={{ height: '80px', borderRadius: '20px 0 0 20px'}}>
                    <Typography variant="body2" sx={{ fontWeight: 'bold' }}>Eco Explorers</Typography>
                </Box>
            </Grid2>
            
            {/* Step 2 */}
            <Grid2 size={2.4}>
                <AvatarClump numberOfAvatars={avatarCount[3]} avatarType={1} actualAvatar={actualAvatar}/>
                <Box className="staircase-block" sx={{ height: '140px'}}>
                    <Typography variant="body2" sx={{ fontWeight: 'bold' }}>Carbon Catalysts</Typography>
                    <Box className='centered-x'>
                        <Typography variant="body2">20&nbsp;</Typography>
                        <PointIcon />
                    </Box>
                </Box>
            </Grid2>
            {/* Step 3 */}
            <Grid2 size={2.4}>
                <AvatarClump numberOfAvatars={avatarCount[2]} avatarType={2} actualAvatar={actualAvatar}/>
                <Box className="staircase-block" sx={{ height: '200px'}}>
                    <Typography variant="body2" sx={{ fontWeight: 'bold' }}>Carbon Crusaders</Typography>
                    <Box className='centered-x'>
                        <Typography variant="body2">100&nbsp;</Typography>
                        <PointIcon />
                    </Box>
                </Box>
            </Grid2>
            {/* Step 4 */}
            <Grid2 size={2.4}>
                <AvatarClump numberOfAvatars={avatarCount[1]} avatarType={3} actualAvatar={actualAvatar}/>
                <Box className="staircase-block" sx={{ height: '260px'}}>
                    <Typography variant="body2" sx={{ fontWeight: 'bold' }}>Carbon Busters</Typography>
                    <Box className='centered-x'>
                        <Typography variant="body2">250&nbsp;</Typography>
                        <PointIcon />
                    </Box>
                </Box>
            </Grid2>
            {/* Step 5 */} 
            <Grid2 size={2.4}>
             <AvatarClump numberOfAvatars={avatarCount[0]} avatarType={4} actualAvatar={actualAvatar}/>
                <Box className="staircase-block" sx={{ height: '320px', borderRadius: '20px 20px 20px 0'}}>
                    <Typography variant="body2" sx={{ fontWeight: 'bold' }}>Green Heroes</Typography>
                    <Box className='centered-x'>
                        <Typography variant="body2">500&nbsp;</Typography>
                        <PointIcon />
                    </Box>
                </Box>
            </Grid2>
        </Grid2>
    );
}
